import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import theme from './styles/theme';
import FunnelContainer from './components/Funnel/FunnelContainer';
import ProtectedAdmin from './components/Admin/ProtectedAdmin';
import ClearStorage from './components/ClearStorage';
import ForwardRedirect from './components/ForwardRedirect';
import StripeProvider from './components/StripeProvider';
import { StripeContextProvider } from './contexts/StripeContext';
import './App.css';

const GA_MEASUREMENT_ID = 'G-W8M7MJK3DH';

// Fire GA4 + Meta pageviews on every SPA route change (skip admin)
const AdPageViews = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith('/admin')) return;

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
        send_to: GA_MEASUREMENT_ID
      });
    }

    if (typeof window.fbq === 'function') {
      window.fbq('track', 'PageView');
    }
  }, [location.pathname, location.search]);

  return null;
};

// Wrapper component that always loads Stripe globally
const AppContent = () => {
  return (
    <StripeProvider shouldLoadStripe={true}>
      <Router 
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <AdPageViews />
        <div className="App">
          <Routes>
            {/* Admin routes */}
            <Route path="/admin" element={<ProtectedAdmin />} />
            
            {/* Clear storage route */}
            <Route path="/clear" element={<ClearStorage />} />

            {/* Paid ad forwarding — establish session, then send to marketing site (path) or in-app screen (key) */}
            <Route path="/fwd" element={<ForwardRedirect />} />
            
            {/* Main funnel routes - order matters! More specific routes first */}
            <Route path="/optimalpace" element={<FunnelContainer />} />
            <Route path="/optimalpace/:shortcode/:screenKey" element={<FunnelContainer />} />
            <Route path="/optimalpace/:shortcode" element={<FunnelContainer />} />
            {/* New route for direct screen access without shortcode - must be last */}
            <Route path="/optimalpace/:screenKey" element={<FunnelContainer />} />
            
            {/* Redirect root to funnel */}
            <Route path="/" element={<Navigate to="/optimalpace" replace />} />
            
            {/* Catch all other routes */}
            <Route path="*" element={<Navigate to="/optimalpace" replace />} />
          </Routes>
        </div>
      </Router>
    </StripeProvider>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <StripeContextProvider>
        <AppContent />
      </StripeContextProvider>
    </ThemeProvider>
  );
}

export default App; 